import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, TextField } from '@shared/ui';

import styles from './Searches.module.css';

/** Ручное имя — 1–80 символов (MVP_PRD §20). Значение то же, что в схеме API. */
export const CUSTOM_TITLE_MAX_LENGTH = 80;

interface RenameFormProps {
  initialTitle: string | null;
  pending: boolean;
  onCancel: () => void;
  /** `null` — вернуть автоматическое название. */
  onSubmit: (title: string | null) => void;
}

/**
 * Переименование прямо в карточке (FE-152).
 *
 * Пустое имя — не ошибка ввода, а осознанный возврат к автоматическому
 * названию (MVP_PRD §20), поэтому форма отправляется и с пустым полем, а
 * подсказка говорит об этом прямо.
 */
export function RenameForm({ initialTitle, pending, onCancel, onSubmit }: RenameFormProps) {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialTitle ?? '');

  return (
    <form
      className={styles.renameForm}
      onSubmit={(event) => {
        event.preventDefault();
        const trimmed = value.trim();
        onSubmit(trimmed === '' ? null : trimmed);
      }}
    >
      <TextField
        className={styles.renameField}
        label={t('searches.rename.label')}
        hint={t('searches.rename.hint')}
        maxLength={CUSTOM_TITLE_MAX_LENGTH}
        value={value}
        autoFocus
        onChange={(event) => {
          setValue(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') onCancel();
        }}
      />
      {/* Форма живёт в карточке: сохранение — действие карточки, синим
          контуром, а не красной заливкой (DESIGN_SYSTEM §5.1). */}
      <Button type="submit" variant="outline-action" disabled={pending}>
        {t('searches.rename.save')}
      </Button>
      <Button type="button" variant="ghost" disabled={pending} onClick={onCancel}>
        {t('searches.rename.cancel')}
      </Button>
    </form>
  );
}
